import BlockIcon from '@mui/icons-material/Block'
import { Box, Button, Paper, Typography } from '@mui/material'

export function DefaultFallback() {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: '98vh', // full height
			}}
		>
			<Paper
				elevation={3}
				sx={{
					p: 4,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					textAlign: 'center',
					gap: 2,
					maxWidth: 400,
					width: '100%',
				}}
			>
				<BlockIcon color="error" sx={{ fontSize: 56 }} />
				<Typography variant="h6" gutterBottom>
					Ad Blocker Detected
				</Typography>
				<Typography variant="body2" color="text.secondary">
					We noticed you’re using an ad blocker. To access this content, please
					disable your ad blocker or exclude this site.
				</Typography>
				<Button
					variant="contained"
					color="primary"
					sx={{ mt: 2 }}
					onClick={() => window.location.reload()}
				>
					Refresh After Disabling
				</Button>
			</Paper>
		</Box>
	)
}
